// extracted by mini-css-extract-plugin
module.exports = {"root":"StandardLayout__root--1YQfV","content":"StandardLayout__content--1wCNV"};